export default __webpack_public_path__ + "static/hands-grip-861c435458b68e0bff692b69a4bfec2f.jpg";